import { useDispatch } from "react-redux"
import { startAlerta } from "../../actions/ui/alertas";
import { startFetch } from "../../services/fetch/startFetch";
import ContratacionesService from "../../services/ContratacionesService";

export const useContratos = () => {
    const dispatch = useDispatch();
    
    const post = {
        contratos: {
            copyConvenios: (values, handleClose) => {
                dispatch(startFetch(
                    () => ContratacionesService.copyConvenios({
                        fechaInicioVigencia: values.fechaInicioVigencia,
                        idEfectorCopy: values.efectorCopy.idEfectorFacturacion,
                        idEfectorPaste: values.efectorPaste.idEfectorFacturacion,
                    }),
                    () => {
                        dispatch(
                            startAlerta(
                                `Contrato Copiado`,
                                'success',
                                'Comando Exitoso',
                            ),
                        )
                        handleClose();
                    })
                );
            }
        }
    }

    return {
        post
    }
}